import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-5 left-5 md:bottom-6 md:left-6 w-11 h-11 rounded-full bg-[#0B0F19] dark:bg-white text-white dark:text-[#0B0F19] shadow-lg flex items-center justify-center z-40 hover:bg-black dark:hover:bg-gray-100 transition-colors"
      data-testid="back-to-top"
      aria-label="Retour en haut"
      title="Retour en haut"
    >
      <ArrowUp size={18} />
    </button>
  );
}
